module.exports = __webpack_public_path__ + "img/chat.d6e98f92.png";